import { Button } from "@material-ui/core";
import { buildFreeMessage, buildQAFormLiveChat, buildQAFormMessage, buildTheEndMessage, checkDataChangeInChatbot, checkMessageOutOfSession, createMessageList, postMessage } from "./handler/ChatBoxHandler";
import { useEffect, useState } from "react";
import { useRecoilValue } from "recoil";
import { updatePreviewSettingAtom } from "@/state/atom/chatBotPreview";
import Constant from "@/common/constant/Constant";
import { v4 as uuidv4} from 'uuid';
import LoadingMessage from "./LoadingMessage";
import React, { memo } from 'react';
import { I18n } from "aws-amplify";
import Utils from "@/common/utils/utils";
import { createKibanaDataEnquete } from "@/component/system/logKibanaHandler/LogKibanaHandler";
import LogKibanaConstant from "@/common/constant/LogKibanaConstant";
import { createKibanaLogAPI } from "@/service/logKibanaService";

function ConfirmMessage({
    message,
    setMessages,
    settingChatBot,
    messages,
    supportThreadIdState,
    affiliationOrganization,
    isModePreview,
    setIsShowModalReload,
    projectAlias,
    subDomain,
    listCategories,
    isMaximizedPanel,
    projectId,
    isIframeChatBot,
    projectInuseDetail,
    currentCorporationDetail,
    isChatRobo,
    API,
    isEnableMsgInput,
    setIsEnableMsgInput,
    getMessage,
    resolvedMessages
}) {
    const [messageState, setMessagesState] = useState(message)
    const previewSetting = useRecoilValue(updatePreviewSettingAtom);
    const [freeMessageContent, setFreeMessageContent] = useState('')
    const [actionWhenNotResolve, setActionWhenNotResolve] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [isDisabledButton, setIsDisableButton] = useState(false);

    useEffect(() =>{
        if (message.idMessage !== messageState.idMessage) {
            setMessagesState(message)
        }
    }, [message])

    useEffect(() => {
        if (!isModePreview) {
            setFreeMessageContent(settingChatBot.freeMsg);
            setActionWhenNotResolve(settingChatBot?.actionWhenNotResolve)
        }
    }, [settingChatBot]);

    useEffect(() => {
        if (isModePreview) {
           if(previewSetting.freeMsg !== freeMessageContent){
                setFreeMessageContent(previewSetting.freeMsg)
           }
           if(previewSetting.actionWhenNotResolve !== actionWhenNotResolve){
                setActionWhenNotResolve(previewSetting.actionWhenNotResolve)
           }
        }
    }, [previewSetting]);

    const onClickYesHandler = () => {
        if (!isModePreview) {
            if (isMsgContentEnquete(messageState)) {
                let dataLog = {
                    qaCategory: getQaCategory(messages, messageState),
                    enqueteResult: I18n.get('COMBTN002'),
                    enqueteFor: isChatRobo ? LogKibanaConstant.ENQUETE_FOR.ROBO : LogKibanaConstant.ENQUETE_FOR.AI
                }

                let logKibanaData = createKibanaDataEnquete(dataLog, currentCorporationDetail, projectInuseDetail)
                let param = {
                    logType: LogKibanaConstant.KNOWLEDGE_ROBO.ENQUETE,
                    logKibanaData: logKibanaData
                };
                createKibanaLogAPI(API, param);
            }
        }
        
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        const newMessage = buildTheEndMessage(0, messageState.content[0]?.formQASystem, resolvedMessages);
        postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview);
        setMessages(pev => [...pev, newMessage]);
        setIsEnableMsgInput(false)
    };

    const onClickNoHandler = async () => {
        setIsDisableButton(true);
        if (!isModePreview) {
            if (isMsgContentEnquete(messageState)) {
                let dataLog = {
                    qaCategory: getQaCategory(messages, messageState),
                    enqueteResult: I18n.get('COMBTN007'),
                    enqueteFor: isChatRobo ? LogKibanaConstant.ENQUETE_FOR.ROBO : LogKibanaConstant.ENQUETE_FOR.AI
                }

                let logKibanaData = createKibanaDataEnquete(dataLog, currentCorporationDetail, projectInuseDetail)
                let param = {
                    logType: LogKibanaConstant.KNOWLEDGE_ROBO.ENQUETE,
                    logKibanaData: logKibanaData
                };
                createKibanaLogAPI(API, param);
            }
        }
        if (checkMessageOutOfSession(messages, messageState.idMessage)) return;
        if(!isModePreview) {
            let validatedChangeData = await checkDataChangeInChatbot(projectAlias, subDomain, settingChatBot, messageState?.content[0]?.categoryIdSelected, listCategories, projectId, isIframeChatBot);
            if (
                !validatedChangeData.status && Utils.isEmptyObject(validatedChangeData.chatbotSettingNew)
                ) {
                setIsShowModalReload(true);
                return;
            }
            if(!validatedChangeData.status && !Utils.isEmptyObject(validatedChangeData.chatbotSettingNew)) {
                let optionsWhennotResolved = validatedChangeData?.chatbotSettingNew?.actionWhenNotResolve;
                renderMessageByOptions(optionsWhennotResolved);
                setIsDisableButton(false);
                setIsShowModalReload(true);
                return;
            }
        }

        renderMessageByOptions(actionWhenNotResolve);
        setIsDisableButton(false);
        setIsEnableMsgInput(false)
    };
    
    const renderMessageByOptions = (optionsWhennotResolved) => {
        switch(optionsWhennotResolved) {
            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_CHAT_WITH_AGENT:
                let idQALivechat = `qaform_${uuidv4()}`
                let dataLiveChat = {
                    isDefault: false,
                    idQA: idQALivechat,
                    categoryIdSelected: message.content[0]?.categoryIdSelected,
                    formQASystem: message.content[0]?.formQASystem
                };
                const newMessages = buildQAFormLiveChat(dataLiveChat, resolvedMessages);
                postMessage(newMessages, supportThreadIdState, affiliationOrganization,false,isModePreview, idQALivechat);
                setMessages(pev => [...pev, newMessages]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.CREATE_TICKET_AND_FINISH:
                let idQA = `qaform_${uuidv4()}`
                let data = {
                    isDefault: false,
                    idQA: idQA,
                    data: {
                        categoryIdSelected: messageState.content[0]?.categoryIdSelected,
                        formQASystem: messageState.content[0]?.formQASystem
                    }
                };
                const newMessage = buildQAFormMessage(data, resolvedMessages);
                postMessage(newMessage, supportThreadIdState, affiliationOrganization,false,isModePreview, idQA);
                setMessages(pev => [...pev, newMessage]);
                break;

            case Constant.SETTING_CHAT_BOT.ACTION_WHEN_NOT_RESOLVE.DISPLAY_FREE_MESSAGE:
                const freeMessage = buildFreeMessage(freeMessageContent,0);
                const theEndMessage = buildTheEndMessage(1, messageState.content[0]?.formQASystem, resolvedMessages);
                createMessageList(
                    [freeMessage, theEndMessage],
                    supportThreadIdState,
                    affiliationOrganization,
                    isModePreview
                );
                setMessages(pev => [...pev, freeMessage, theEndMessage]);
                break;

            default:
                break;
        }
    }

    const isMsgContentEnquete = (msg) => {
        if (!Utils.isEmptyArray(msg?.content)) {
            let msgKeyContent = msg?.content[0];
            if (msgKeyContent?.msgKey === I18n.get('CBOTLB001')) {
                return true;
            }
        }
        return false;
    }

    const getQaCategory = (listMsg, msgSelect) => {
        let categoryId = msgSelect?.content[0].categoryIdSelected;
        let qaCategory = '';
        let msgEnquete = listMsg.find(msg => msg?.idOfOption === categoryId);
        if (msgEnquete) {
            qaCategory = msgEnquete?.content;
        }
        return qaCategory;
    }

    return (
        <>
            <div
                className={
                    isMaximizedPanel
                        ? 'message-text confirm-message maximized-form-text'
                        : 'message-text confirm-message'
                }
            >
                <div className="text-question">{getMessage('bot_confirm_resolved')}</div>
                <Button onClick={onClickYesHandler} className="confirm-resolved">
                    {getMessage('bot_confirm_yes_label')}
                </Button>
                <Button
                    onClick={onClickNoHandler}
                    className="confirm-unresolved"
                    disabled={isDisabledButton}
                >
                    {getMessage('bot_confirm_no_label')}
                </Button>
                <div className="text-question" style={{fontSize: '10px'}}>{message?.messageChatAI}</div>
            </div>
            {isLoading && (
                <div className="message-text">
                    <LoadingMessage />
                </div>
            )}
        </>
    );
}

export default memo(ConfirmMessage);